/**
 * Numbering for numbered lists that sit under an already-numbered row (e.g. a
 * Summary Terms row "1. Covenants"). Items are numbered within the row —
 * 1.1, 1.2, 1.3… — and the count continues across the row's numbered-list
 * blocks, instead of every list restarting at "1." and repeating the row's
 * own number.
 */
export function scopedListLabel<T>(
  rowNumber: unknown,
  blocks: readonly T[],
  block: T,
  itemIndex: number,
  isNumberedList: (block: T) => boolean,
  itemCount: (block: T) => number,
): string {
  let position = itemIndex + 1;

  for (const previous of blocks) {
    if (previous === block) {
      break;
    }

    if (isNumberedList(previous)) {
      position += itemCount(previous);
    }
  }

  const row = String(rowNumber ?? '').trim().replace(/\.$/, '');

  return row ? `${row}.${position}` : `${position}.`;
}
